class Mf {

    constructor(apiService = null) {
        this.obj_name = 'mf';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            // { condition: formData.vet_doctor === -1 , message: '請選擇獸醫師' },
            { condition: formData.recorder === '', message: '請選擇紀錄人員' },
            { condition: formData.measurer === '', message: '請選擇測量者' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        //檢查表單必填
        for (let mainIndex = 0; mainIndex < formData.forms.length; mainIndex++) {
            const main = formData.forms[mainIndex];
            for (let subIndex = 0; subIndex < main.sub_items.length; subIndex++) {
                const sub =  main.sub_items[subIndex]
                for (let colIndex = 0; colIndex < sub.cols.length; colIndex++) {
                    const col =  sub.cols[colIndex]
                    if ( 
                        col.col_form_is_required &&
                        col.col_form === ''
                     ){
                        return { status: false, message:`${sub.sub_item_name}項目內的${col.col_name} 為必填。` };
                    }
                }
            }
        }

        return { status: true };
    }

    // API 方法
    //型質測量 | 101新增型質測量表
    async addMeasurementFormTemplate(parameter , progressEvent = null) {
        return this.callApi('post', 'addMeasurementFormTemplate', parameter , progressEvent);
    }
    // 型質測量 | 102取得型質測量詳細資料
    async getMeasurementFormTemplateDetail(parameter) {
        return this.callApi('get', 'getMeasurementFormTemplateDetail', parameter);
    }
    // 型質測量 | 103更新型質測量表
    async updMeasurementFormTemplate(parameter, progressEvent = null) {
        return this.callApi('post', 'updMeasurementFormTemplate', parameter, progressEvent);
    }
    // 型質測量 | 104搜尋型質測量表
    async getMeasurementFormTemplateByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMeasurementFormTemplateByKeywordWithPage', parameter );
    }
    //型質測量 | 105新增型質測量紀錄
    async addMeasurementFormRecord(parameter , progressEvent = null) {
        return this.callApi('post', 'addMeasurementFormRecord', parameter , progressEvent);
    }
    //型質測量 | 106更新型質測量紀錄
    async updMeasurementFormRecord(parameter , progressEvent = null) {
        return this.callApi('post', 'updMeasurementFormRecord', parameter , progressEvent);
    }
    // 型質測量 | 107搜尋型質測量紀錄
    async getMeasurementFormRecordByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMeasurementFormRecordByKeywordWithPage', parameter );
    }
    // 型質測量 | 08取得型質測量紀錄詳細資料
    async getMeasurementFormRecordDetail(parameter) {
        return this.callApi('get', 'getMeasurementFormRecordDetail', parameter );
    }
}
export default Mf;